import React, {useEffect, useState} from "react";
import {HeaderDashboard, SideNav} from "../Componat/Header and Side Nav/NavComponant";
import "./form9Edit.css";
import {Form9BigTable, Section1Form9, Section2Form9} from "./Form9Componant";
import {useSelector} from "react-redux";

export default function () {
    const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);
    const today = new Date();                  // Get today's date
    const currentYear = today.getFullYear();    // Get current year (example: 2025)

    const [selectedYear, setSelectedYear] = useState(`${currentYear}/${currentYear + 1}`);
    return  (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                {/* Main Content */}
                <main className={`p-4 w-100 main`}>
                    <div className={"card p-2 mb-3 bg-success text-white"}>
                        <h4>Add Form 9 (नमुना ९ )</h4>
                        <div className="d-flex justify-content-between">
                            <p>
                                To print this page set "Legal size" page and printing scale is (90%). in print setup Dialogbox.
                            </p>
                            <YearSelect selectedYear={selectedYear} setSelectedYear={setSelectedYear}/>
                        </div>
                    </div>
                    <Form9Data selectedYear={selectedYear}/>
                    <div className="justify-content-center text-center">
                        <button className="btn btn-success m-2">Update</button>
                        <button className="btn btn-primary m-2">Cancel</button>
                    </div>
                </main>
            </div>
        </div>
    )
}

const Form9Data=React.memo(({selectedYear})=>{
    const form8data = useSelector((state) => state.form8?.form8data);
    const [form9Data,setForm9Data]=useState(form8data)


    return (
        <div className={"card p-1 "}>
            <div className={"text-center "}>
                <h5 className="fw-bold">नमुना क्रमांक ९ ( कर मागणी, वसुली, रजिस्टर )</h5>
            </div>

            <div className={"w-100 enable-scroll"}>

                {/*==========Section1============*/}
                <Section1Form9 form9Data={form9Data}/>
                {/*==========Section2============*/}
                <Section2Form9 form9Data={form9Data}/>
                {/*==========Big Table============*/}
                <Form9BigTable selectedYear={selectedYear} form9Data={form9Data}/>

                <div className=" bottom-width mt-3 d-flex justify-content-between">
                    <span>
                        दिनांक
                    </span>
                    <span>
                        ग्रामपंचायत शिक्का
                    </span>
                    <span>
                        ग्रामसेवक ग्रा.प.
                    </span>
                </div>
            </div>
        </div>
    )
})




const YearSelect = ({selectedYear, setSelectedYear}) => {
    const startYear = 2015;
    const currentYear = new Date().getFullYear();
    const endYear = currentYear + 1;

    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push(`${year}/${year + 1}`);
    }

    //const [selectedYear, setSelectedYear] = useState(`${currentYear}/${currentYear + 1}`);

    const handleChange = (e) => {
        setSelectedYear(e.target.value);
    };

    return (
        <div>
            <select value={selectedYear} onChange={handleChange}>
                {years.map((yearOption, index) => (
                    <option key={index} value={yearOption}>
                        {yearOption}
                    </option>
                ))}
            </select>
        </div>
    );
};



